import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";

export const useAuthentication = (isAuthenticated: boolean): void => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      const currentRoute = location.pathname;
      const params = location.search;
      const nextPageUrl = encodeURIComponent(`${currentRoute}${params}`);
      navigate(`/?nextPage=${nextPageUrl}`);
    }
  }, [isAuthenticated, navigate, location]);
};
